export default __webpack_public_path__ + "static/media/futura-bold.b4d7b760.woff";